"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildColorsByBrand = void 0;
const colors_1 = require("./colors");
// Builds the theme colors for the MUI theme object based on a specific brand identity.
// We want to change certain colors in the app based on which domain/brand identity is passed at any given time.
const buildColorsByBrand = (brandName) => {
    const brandColors = colors_1.ColorSetLookup[brandName];
    // Last operand of a spread overrides pervious values. Ensuring brands take precedence if duplicate color entries exist.
    const compiledColors = Object.assign(Object.assign({}, colors_1.CoreColors), brandColors);
    return { colors: compiledColors, accentColors: colors_1.AccentColors };
};
exports.buildColorsByBrand = buildColorsByBrand;
//# sourceMappingURL=buildColorsByBrand.js.map